import { ContainerModule } from 'inversify';
import AddressesRepository from '../features/addresses/data/AddressesRepository';
import { AddressesServiceInterface } from '../features/addresses/data/service/addressesService.types';
import { AddressesRepositoryInterface } from '../features/addresses/domain/AddressesRepositoryInterface';
import AddressesService from 'src/features/addresses/data/service/addressesService';
import { GetAddressByLocationUseCaseInterface } from 'src/features/addresses/domain/UseCases/types';
import GetAddressByLocationUseCase from 'src/features/addresses/domain/UseCases/GetAddressByLocationUseCase';
import DeleteAddressUseCase from 'src/features/addresses/domain/UseCases/DeleteAddressUseCase';
import { LocationServiceInterface } from 'src/features/addresses/data/service/locationService.types';
import LocationService from 'src/features/addresses/data/service/locationService';

export const addressesBindings = new ContainerModule((bind) => {
  // Services
  bind<LocationServiceInterface>(LocationService).to(LocationService);
  bind<AddressesServiceInterface>(AddressesService).to(AddressesService);

  // Repositories
  bind<AddressesRepositoryInterface>(AddressesRepository).to(
    AddressesRepository
  );

  // Use cases
  bind<GetAddressByLocationUseCaseInterface>(GetAddressByLocationUseCase).to(
    GetAddressByLocationUseCase
  );
  bind<DeleteAddressUseCase>(DeleteAddressUseCase).to(DeleteAddressUseCase);
});
